<template>
  <div>
    <!--
    <SegmentControl
      class="margin-bottom-2"
      :active-index.sync="activeIndex"
      size="small"
      :segments="[{ label: 'Recent' }, { label: 'Popular' }]"
      :initial-active-index="0"
    ></SegmentControl>

    <FormInput
      v-model="searchQuery"
      class="margin-bottom-4"
      placeholder="Search..."
    ></FormInput>
    -->

    <div class="saas-listing-page__sidebar-small-title">Topics</div>
    <ul class="saas-listing-page__categories">
      <li
        v-for="category in categories"
        :key="category.slug"
        class="saas-listing-page__categories-item"
      >
        <nuxt-link
          :to="{
            name: 'blog-filtered',
            params: {
              category: category.slug,
            },
          }"
          class="saas-listing-page__categories-link"
          :class="{
            'saas-listing-page__categories-link--active':
              category.slug === selectedCategory,
          }"
          >{{ category.name }}</nuxt-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BlogPostCategorySelect',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    selectedCategory: {
      type: String,
      required: true,
      default: 'all',
    },
  },
  data() {
    return {
      searchQuery: '',
      segments: [{ name: 'Recent' }, { name: 'Popular' }],
      // categories: [
      //   { name: 'All topics', slug: 'all' },
      //   { name: 'Info', slug: 'info' },
      //   { name: 'Development', slug: 'development' },
      //   { name: 'Tutorials', slug: 'tutorials' },
      //   { name: 'Company', slug: 'company' },
      // ],
      activeIndex: null,
    }
  },
}
</script>
